import { Navigate, Route, Routes } from 'react-router-dom'
import { ToastProvider } from 'components/common/Toast'
import { RequireSession } from 'auth/RequireSession'
import EntityEdit from 'pages/EntityEdit'
import EntityView from 'pages/EntityView'
import Home from 'pages/Home'
import Login from 'pages/Login'
import SSOCallback from 'pages/SSOCallback'

export default function App() {
  return (
    <ToastProvider>
      <Routes>
        {/* SSO entry points — outside the session guard. */}
        <Route path="/callback" element={<SSOCallback />} />
        <Route path="/login" element={<Login />} />

        <Route path="/" element={<RequireSession><Home /></RequireSession>} />
        {/* Mirrors EntityViewDetails.aspx?entityType=…&entityID=… or ?q=… */}
        <Route path="/view" element={<RequireSession><EntityView /></RequireSession>} />
        <Route path="/view/:entityType/:entityId" element={<RequireSession><EntityView /></RequireSession>} />
        <Route path="/EntityViewDetails.aspx" element={<RequireSession><EntityView /></RequireSession>} />
        <Route path="/UserCRMCampaign/EntityViewDetails.aspx" element={<RequireSession><EntityView /></RequireSession>} />

        <Route path="/edit" element={<RequireSession><EntityEdit /></RequireSession>} />
        <Route path="/edit/:entityType/:entityId" element={<RequireSession><EntityEdit /></RequireSession>} />
        <Route path="/EntityEdit.aspx" element={<RequireSession><EntityEdit /></RequireSession>} />
        <Route path="/UserCRMCampaign/EntityEdit.aspx" element={<RequireSession><EntityEdit /></RequireSession>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ToastProvider>
  )
}
